import { createMuiTheme, Theme } from '@material-ui/core';
import { colors } from './styleConstants';

export const theme: Theme = createMuiTheme({
  palette: colors,
});
